import React from 'react';

import SubAccountForm from '../SubAccountForm';

class CreateSubAccount extends React.Component {

    render() {
        return (
            <div>
                <SubAccountForm />
            </div>
        );
    }
}

export default CreateSubAccount;



// WEBPACK FOOTER //
// ./src/pages/SubAccountManagement/CreateSubAccount/index.js